module.exports = __webpack_public_path__ + "img/services-6.d52de4c0.jpg";